"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import { CardIconCoveredParking } from "./CardIconCoveredParking";
import { CardIconDogPark } from "./CardIconDogPark";
import { CardIconEvCharging } from "./CardIconEvCharging";
import { CardIconFitness } from "./CardIconFitness";
import { CardIconPet } from "./CardIconPet";
import { CardIconPool } from "./CardIconPool";
import { CardIconPrivateGarage } from "./CardIconPrivateGarage";
import { CardIconWashDry } from "./CardIconWashDry";

export function PropertyCardFullWidth({
  address = "10001 West View Ave, Sacramento, California",
  amenitySlot,
  bedrooms = "1, 2, 3",
  linkProps,
  name = "This is the default text value",
  slideSlot,
  startingPrice = "$1,111",
}) {
  return (
    <Block className={"horizontal-card"} tag={"div"}>
      <Block className={"card_asset-large-format"} tag={"div"}>
        {slideSlot ?? (
          <Block className={"card_slider-image-wrapper"} tag={"div"}>
            <Image
              className={"card_slider-image"}
              height={"159"}
              loading={"lazy"}
              src={
                "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dfccab65dbeca288e60830_goldenwest-default.jpg"
              }
              width={"232"}
            />
          </Block>
        )}
      </Block>
      <Block className={"copy"} tag={"div"}>
        <Block className={"name-address"} tag={"div"}>
          <Heading className={"name-full-width"} tag={"h2"}>
            {name}
          </Heading>
          <Block className={"frame-214"} tag={"div"}>
            <Image
              aria-hidden={"true"}
              className={"vectors-wrapper-15"}
              height={"13"}
              loading={"lazy"}
              src={
                "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728687c8a1b4c6aab7697d_Vectors-Wrapper.svg"
              }
              width={"9"}
            />
            <Paragraph className={"text-51"}>{address}</Paragraph>
          </Block>
        </Block>
        <Block className={"beds-and-starting-price"} tag={"div"}>
          <Block className={"beds"} tag={"div"}>
            <Paragraph className={"bedlabel"}>{"bedrooms"}</Paragraph>
            <Paragraph className={"text-52"}>{bedrooms}</Paragraph>
          </Block>
          <Block className={" beds"} tag={"div"}>
            <Paragraph className={" bedlabel"}>{"Starting at"}</Paragraph>
            <Paragraph className={" text-52"}>{startingPrice}</Paragraph>
          </Block>
        </Block>
        <Block className={"amenities-large"} tag={"div"}>
          {amenitySlot ?? (
            <>
              <CardIconPet />
              <CardIconDogPark />
              <CardIconPool />
              <CardIconFitness />
              <CardIconWashDry />
              <CardIconEvCharging />
              <CardIconCoveredParking />
              <CardIconPrivateGarage />
            </>
          )}
        </Block>
        <Block className={"frame-215"} tag={"div"}>
          <Link button={false} className={"frame-216"} options={linkProps}>
            <Paragraph className={"text-53"}>{"View Home"}</Paragraph>
          </Link>
        </Block>
      </Block>
    </Block>
  );
}
